<template>
    <div v-show="visible">
        <el-dialog title="修改" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="450px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="120px">
                    <el-form-item prop="content" label="界面展示内容">
                        <el-input  type="textarea" :rows="5" v-model="form.content" maxlength="5000" show-word-limit></el-input>
                    </el-form-item>

                    <el-form-item   prop="operateType" label="操作类型">
                       <el-select v-model="form.operateType" placeholder="请选择" clearable style="width:290px;">
                            <el-option
                                v-for="item in operateTypes"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item   prop="componentType" label="组件类型">
                       <el-select v-model="form.componentType" placeholder="请选择" clearable style="width:290px;">
                            <el-option
                                v-for="item in componentTypes"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    
                    <el-form-item prop="checkUsers" label="审核人">
                        <el-button @click="findUser()">{{form.checkUsersLabel}}</el-button>
                    </el-form-item>

                    <el-form-item   prop="orderNum" label="排序号">
                        <el-input v-model="form.orderNum" maxlength="3" type="number" style="width:70px;"></el-input>
                    </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
        <!-- 人员弹出框 -->
        <div v-if="transferVisible">
            <userTransfer ref="userTransfer"></userTransfer>
        </div>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import userTransfer from '../../sys/user/UserTransfer.vue';

    export default {
        data(){
            return{
                visible: false,
                transferVisible:false,
                form:{
                    id:"",
                    deptId:"",
                    operateType:"",
                    componentType:"",
                    content:"",
                    orderNum:"",
                    checkUsers:[],
                    checkUsersLabel:"请选择",
                },
                rules: {
                    operateType: [
                        { required: true, message: '请选择操作类型', trigger: 'blur' }
                    ],
                    componentType: [
                        { required: true, message: '请求选择组件类型', trigger: 'blur' }
                    ],
                    content: [
                        { required: true, message: '请输入界面展示内容', trigger: 'blur' }
                    ]
                },
                operateTypes:[{
                    value: 1,
                    label: '一级目录'
                }, {
                    value: 2,
                    label: '二级目录'
                }, {
                    value: 3,
                    label: '三级目录'
                }, {
                    value: 4,
                    label: '四级目录'
                }, {
                    value: 5,
                    label: '五级目录'
                }, {
                    value: 9,
                    label: '填写'
                }],
                componentTypes:[{
                    value: 1,
                    label: '标签'
                },
                //  {
                //     value: 2,
                //     label: '单行文本框'
                // }, {
                //     value: 3,
                //     label: '多行文本框'
                // }, {
                //     value: 4,
                //     label: '图片与视频'
                // }, {
                //     value: 5,
                //     label: '签名'
                // }, {
                //     value: 6,
                //     label: '图片与视频+附件'
                // }, 
                {
                    value: 7,
                    label: '自定义(JSON格式)'
                }],
            }
        },
        created:function () {
        },
        components: {
            userTransfer
        },
        methods:{
            init(data){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                // console.log(JSON.stringify(data));
                this.form.id=data.id;
                this.form.content=data.text;
                this.form.operateType=data.attributes.operateType;
                this.form.componentType=data.attributes.componentType;
                this.form.orderNum=data.attributes.orderNum;
                if( data.attributes.checkUser!=null && data.attributes.checkUser!='' ){
                    this.form.checkUsers=data.attributes.checkUser.split(',');
                    this.form.checkUsersLabel=data.attributes.checkUser.split(',').length+"人";
                }else{
                    this.form.checkUsers=[];
                    this.form.checkUsersLabel="请选择";
                }
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        let url= this.teacherTemplateConfigUpdateUrl;
                        let data = {
                            id:this.form.id,
                            deptId:this.form.deptId,
                            parentId:this.form.parentId,
                            operateType:this.form.operateType,
                            componentType:this.form.componentType,
                            content:this.form.content,
                            checkUser:this.form.checkUsers.join(),
                            // componentShowUsers:this.form.componentShowUsers,
                            orderNum:this.$util.isNotEmpty(this.form.orderNum)?this.form.orderNum:"",
                        };
                        // console.log(JSON.stringify(data));
                        // return;
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                        }, (err) => {
                            console.log(err);
                        });
                    }
               });
            },
            // 绑定人员
            findUser(){
                this.transferVisible=true;
                this.$nextTick(() => {
                    if(this.form.checkUsers.length > 0){
                        this.$refs['userTransfer'].init(2,this.form.checkUsers,2,this.form.deptId);
                    }else{
                        this.$refs['userTransfer'].init(2,null,2,this.form.deptId);
                    }
                })
            },
            setUser(keyArr){
                if(keyArr.length == 0){
                    this.form.checkUsers=keyArr;
                    this.form.checkUsersLabel="请选择";
                }else{
                    this.form.checkUsers=keyArr;
                    this.form.checkUsersLabel=keyArr.length+"人";
                }
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/teacher/config/Update.vue